import { useState } from 'react';
import { useDispatch } from 'react-redux';

//
import { setHeader } from '../../../../../../../Redux/slices/certificate';

//
import Text from '../../../molecules/Text';

/**
 *
 */
function Title({ headerState, preview }) {
  const { title } = headerState;
  const { text, color, fontSize, alignment } = title;
  const dispatch = useDispatch();

  const [show, setShow] = useState(false);

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  const handleSave = (titleValue) => {
    dispatch(
      setHeader({
        ...headerState,
        title: titleValue
      })
    );
  };

  return (
    <Text
      show={show}
      text={text}
      color={color}
      title="Title"
      preview={preview}
      initialValue={title}
      fontSize={fontSize}
      alignment={alignment}
      //
      handleSave={handleSave}
      handleShow={handleShow}
      handleClose={handleClose}
    />
  );
}

export default Title;
